import { Button, Grid, IconButton, List, ListItemButton, ListItemText, Paper, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { downloadInvoicingReportRequest, downloadInvoicingReportReset, fetchInvoicinglogRequest, generateFinalChargesRequest, generateShipmentChargesRequest, } from "@/redux/actions";
import { enqueueSnackbar } from "notistack";
import { formatDateRangeForBillingCycle, getDateString } from "@/utils/Common";
import BackDropComponent from "@/components/BackDrop";
import AddRecordSliderbarPage from "./AddRecordSlidebar";
import { useBillingCycles } from "@/hooks/useBillingCycles";
const headCells = [
    {
        id: "billingCycle",
        disablePadding: true,
        label: "Billing Cycle",
    },
    {
        id: "weightDiscrepency",
        disablePadding: true,
        label: "Weight discrepency",
    },
    {
        id: "codRemittence",
        disablePadding: true,
        label: "COD remittence",
    },
    {
        id: "shipmentCharges",
        disablePadding: true,
        label: "Shipment charges",
    },
    // {
    //   id: "shipmentAnalysis",
    //   disablePadding: true,
    //   label: "Shipment analysis",
    // },
    {
        id: "controls",
        disablePadding: true,
        label: "",
    },
];
function EnhancedTableHead(props) {
    const { rowCount } = props;
    return (React.createElement(TableHead, { sx: { p: 2 }, style: { background: "#FAFBFC" } },
        React.createElement(TableRow, null, headCells.map((headCell) => {
            return (React.createElement(TableCell, { key: headCell.id, align: "left", className: "orderTable_heading_font", padding: "normal" }, headCell.label));
        }))));
}
const InvoicingPage = () => {
    const [invoices, setInvoices] = useState([]);
    const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [nextPage, setNextPage] = React.useState(null); // next page data
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const [page, setPage] = React.useState(0);
    const dispatch = useDispatch();
    const [totalCount, setTotalCount] = React.useState(0);
    const billingCycles = useBillingCycles();
    const invoicingState = useSelector((state) => state.invoicingLogReducer);
    const downloadInvoicingReportState = useSelector((state) => state.downloadInvoicingReportData);
    const generateShipmentChargesState = useSelector((state) => state.GenerateShipmentChargesReducer);
    const generateFinalChargesState = useSelector((state) => state.GenerateFinalChargesReducer);
    React.useEffect(() => {
        if (invoicingState && _.has(invoicingState, "data.reportMetadataRecords")) {
            if (!_.isEmpty(invoicingState.data.reportMetadataRecords)) {
                const invoicesComing = [...invoicingState.data.reportMetadataRecords];
                setInvoices(invoicesComing);
                setTotalCount(invoicingState.data.totalRecords);
            }
            setIsBackOpenOpen(false);
        }
        else if (invoicingState.error) {
            if (invoicingState.error instanceof Error) {
                enqueueSnackbar(invoicingState.error.message, {
                    variant: "error",
                });
            }
            setIsBackOpenOpen(false);
        }
    }, [invoicingState, dispatch]);
    React.useEffect(() => {
        if (generateShipmentChargesState && _.has(generateShipmentChargesState, "data.fileName")) {
            setIsBackOpenOpen(false);
            enqueueSnackbar("Shipment charges generated Successfully.", {
                variant: "success",
            });
        }
        else if (generateShipmentChargesState.error) {
            if (generateShipmentChargesState.error instanceof Error) {
                enqueueSnackbar(generateShipmentChargesState.error.message, {
                    variant: "error",
                });
            }
            setIsBackOpenOpen(false);
        }
    }, [generateShipmentChargesState]);
    React.useEffect(() => {
        if (generateFinalChargesState && _.has(generateFinalChargesState, "data.jobIds")) {
            setIsBackOpenOpen(false);
            enqueueSnackbar("Final charges generated Successfully.", {
                variant: "success",
            });
        }
        else if (generateFinalChargesState.error) {
            if (generateFinalChargesState.error instanceof Error) {
                enqueueSnackbar(generateFinalChargesState.error.message, {
                    variant: "error",
                });
            }
            setIsBackOpenOpen(false);
        }
    }, [generateFinalChargesState]);
    const handleClickPopOver = (event, batch) => {
        setAnchorEl(event.currentTarget);
        // setSelectedBatch(batch);
    };
    const fetchInvoicingDetails = (pageSize, pageNumber) => {
        setIsBackOpenOpen(true);
        dispatch(fetchInvoicinglogRequest({
            pageSize: pageSize,
            pageNumber: pageNumber ? pageNumber : 0,
        }));
    };
    const handleClosePopOver = () => {
        setAnchorEl(null);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        if (totalCount / rowsPerPage <= newPage) {
            fetchInvoicingDetails(rowsPerPage);
        }
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setNextPage(null);
        setInvoices([]);
        fetchInvoicingDetails(parseInt(event.target.value, 10));
    };
    React.useEffect(() => {
        setIsBackOpenOpen(true);
        fetchInvoicingDetails(rowsPerPage);
        setNextPage(null);
    }, []);
    const handleOrderStatusClick = () => {
        setIsRightSidebarOpen(true);
        setAnchorEl(null);
    };
    const handleGenerateShipmentChargesClick = () => {
        setIsBackOpenOpen(true);
        dispatch(generateShipmentChargesRequest({}));
    };
    const handleGenerateFinalChargesClick = () => {
        setIsBackOpenOpen(true);
        dispatch(generateFinalChargesRequest({}));
    };
    const handleDownloadReportSave = (filePath) => {
        setIsBackOpenOpen(true);
        dispatch(downloadInvoicingReportRequest({
            filePath: filePath,
        }));
    };
    const handleDownload = (data, extension) => {
        let type = extension === "pdf" ? "application/pdf" : extension === "png" ? "image/png" : `application/${extension}`;
        if (extension === "xlsx")
            type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blobData = data instanceof Uint8Array ? new Blob([data], { type }) : data;
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.download = `report.${extension}`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };
    React.useEffect(() => {
        if (downloadInvoicingReportState.data) {
            setIsBackOpenOpen(false);
            handleDownload(downloadInvoicingReportState.data, "xlsx");
            dispatch(downloadInvoicingReportReset());
        }
        else if (downloadInvoicingReportState.error) {
            enqueueSnackbar("Unable to download payment report", {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [downloadInvoicingReportState]);
    return (React.createElement(Grid, { container: true, direction: "column", sx: { p: 5, height: "calc(100vh - 66px)" }, className: "m_background_color" },
        React.createElement(Grid, { item: true, container: true, mb: 2, gap: 2, sx: { mt: 3 } },
            React.createElement(Grid, null,
                React.createElement(Typography, { sx: {
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: 600,
                        lineHeight: "30px",
                        textAlign: "left",
                        color: "#121114",
                    } }, "Invoicing")),
            React.createElement(Grid, { className: "m_border_grey m_bg_wt", sx: { p: 2 }, item: true, xs: 12, container: true, direction: "row", alignItems: "center", justifyContent: "space-between", padding: 1 },
                React.createElement(Grid, { item: true, container: true, justifyContent: "flex-end" },
                    React.createElement(Grid, { item: true, className: "or_group_button_height" },
                        React.createElement(Button, { variant: "contained", className: "or_group_button_height", size: "small", startIcon: React.createElement(AddIcon, null), sx: { textTransform: "none" }, onClick: handleOrderStatusClick }, "Add Record")))),
            React.createElement(Grid, { container: true, direction: "row", className: "m_background_color" },
                React.createElement(Paper, { sx: { width: "100%" } },
                    React.createElement(TableContainer, null,
                        React.createElement(Table, { sx: { minWidth: 750 }, className: "or_table", "aria-labelledby": "tableTitle", size: "medium" },
                            React.createElement(EnhancedTableHead, { rowCount: totalCount }),
                            React.createElement(TableBody, null, invoices && (invoices === null || invoices === void 0 ? void 0 : invoices.length) > 0 ? (invoices === null || invoices === void 0 ? void 0 : invoices.map((row, index) => {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                                return (React.createElement(TableRow, { hover: true, key: index, role: "checkbox", tabIndex: -1, sx: { cursor: "pointer" } },
                                    React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                        React.createElement(Typography, { variant: "subtitle1", className: "m_font_size_12 orderTable_font", sx: { wordWrap: "break-word", textAlign: "left" } }, formatDateRangeForBillingCycle(row === null || row === void 0 ? void 0 : row.billingCycle)),
                                        React.createElement(Typography, { variant: "body2", className: "orderTable_small_font m_font_size_11" }, row.createdAt ? getDateString(+row.createdAt, "MM-DD-YYYY hh:mm a") : "-")),
                                    React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                        React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                textAlign: "left",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                maxWidth: "200px",
                                                cursor: "pointer",
                                                color: "#0C77FF",
                                            }, onClick: () => {
                                                var _a, _b, _c;
                                                return ((_a = row === null || row === void 0 ? void 0 : row.weightDiscrepancy) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                                    handleDownloadReportSave((_c = row === null || row === void 0 ? void 0 : row.weightDiscrepancy[((_b = row === null || row === void 0 ? void 0 : row.weightDiscrepancy) === null || _b === void 0 ? void 0 : _b.length) - 1]) === null || _c === void 0 ? void 0 : _c.filePath);
                                            }, title: ((_a = row === null || row === void 0 ? void 0 : row.weightDiscrepancy) === null || _a === void 0 ? void 0 : _a.length) > 0
                                                ? (_c = row === null || row === void 0 ? void 0 : row.weightDiscrepancy[((_b = row === null || row === void 0 ? void 0 : row.weightDiscrepancy) === null || _b === void 0 ? void 0 : _b.length) - 1]) === null || _c === void 0 ? void 0 : _c.fileName
                                                : "-" }, ((_d = row === null || row === void 0 ? void 0 : row.weightDiscrepancy) === null || _d === void 0 ? void 0 : _d.length) > 0
                                            ? (_f = row === null || row === void 0 ? void 0 : row.weightDiscrepancy[((_e = row === null || row === void 0 ? void 0 : row.weightDiscrepancy) === null || _e === void 0 ? void 0 : _e.length) - 1]) === null || _f === void 0 ? void 0 : _f.fileName
                                            : "")),
                                    React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                        React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                textAlign: "left",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                maxWidth: "200px",
                                                cursor: "pointer",
                                                color: "#0C77FF",
                                            }, onClick: () => {
                                                var _a, _b, _c;
                                                return ((_a = row === null || row === void 0 ? void 0 : row.codRemittance) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                                    handleDownloadReportSave((_c = row === null || row === void 0 ? void 0 : row.codRemittance[((_b = row.codRemittance) === null || _b === void 0 ? void 0 : _b.length) - 1]) === null || _c === void 0 ? void 0 : _c.filePath);
                                            }, title: ((_g = row === null || row === void 0 ? void 0 : row.codRemittance) === null || _g === void 0 ? void 0 : _g.length) > 0
                                                ? (_j = row === null || row === void 0 ? void 0 : row.codRemittance[((_h = row === null || row === void 0 ? void 0 : row.codRemittance) === null || _h === void 0 ? void 0 : _h.length) - 1]) === null || _j === void 0 ? void 0 : _j.fileName
                                                : "-" }, ((_k = row === null || row === void 0 ? void 0 : row.codRemittance) === null || _k === void 0 ? void 0 : _k.length) > 0
                                            ? (_m = row === null || row === void 0 ? void 0 : row.codRemittance[((_l = row === null || row === void 0 ? void 0 : row.codRemittance) === null || _l === void 0 ? void 0 : _l.length) - 1]) === null || _m === void 0 ? void 0 : _m.fileName
                                            : "")),
                                    React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                        React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                                textAlign: "left",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                maxWidth: "200px",
                                                cursor: "pointer",
                                                color: "#0C77FF",
                                            }, onClick: () => { var _a; return handleDownloadReportSave((_a = row === null || row === void 0 ? void 0 : row.shipmentCharges) === null || _a === void 0 ? void 0 : _a.filePath); }, title: (_o = row === null || row === void 0 ? void 0 : row.shipmentCharges) === null || _o === void 0 ? void 0 : _o.fileName }, (_p = row === null || row === void 0 ? void 0 : row.shipmentCharges) === null || _p === void 0 ? void 0 : _p.fileName)),
                                    React.createElement(TableCell, { className: "orderTable_font", align: "center" },
                                        React.createElement(IconButton, { onClick: (event) => handleClickPopOver(event, row) },
                                            React.createElement(MoreVertIcon, null)))));
                            })) : (React.createElement(TableRow, null,
                                React.createElement(TableCell, { colSpan: 9, align: "center" }, "No Invoices available")))))),
                    React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: totalCount || 0, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })),
                React.createElement(Popover, { id: id, open: Boolean(anchorEl), anchorEl: anchorEl, onClose: handleClosePopOver, slotProps: {
                        paper: {
                            sx: {
                                boxShadow: "0px 4px 4px 0px rgba(206, 216, 228, 0.25)",
                                border: "1px solid #EAEBF1",
                            },
                        },
                    }, anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                    }, transformOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    } },
                    React.createElement(List, null, invoices ? (React.createElement(React.Fragment, null,
                        React.createElement(ListItemButton, null,
                            React.createElement(ListItemText, { primary: "Generate shipment charges", onClick: handleGenerateShipmentChargesClick })),
                        React.createElement(ListItemButton, null,
                            React.createElement(ListItemText, { primary: "Generate final charges", onClick: handleGenerateFinalChargesClick })))) : (React.createElement(Typography, { variant: "body2", color: "error" }, "No Invoice selected")))))),
        isRightSidebarOpen && (React.createElement(AddRecordSliderbarPage, { isOpen: isRightSidebarOpen, setIsRightSidebarOpen: setIsRightSidebarOpen })),
        React.createElement(BackDropComponent, { open: isBackOpenOpen })));
};
export default InvoicingPage;
